// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8029":"366ccb1a","9551":"227098aa"}[chunkId] + ".chunk.css";
};